export default __webpack_public_path__ + "static/media/Group9259.5483553e.svg";